import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { LockIcon, AlertCircle } from "lucide-react";
import { useEffect } from "react";
import { useAuthStore } from "@/utils/UseAuthStore";

const PermissionDenied: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());

  useEffect(() => {
    const theme = localStorage.getItem("theme") || "dark";
    if (theme === "dark") {
      document.querySelector("html")?.classList.add("dark");
    } else {
      document.querySelector("html")?.classList.remove("dark");
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-950">
      <Card className="w-full max-w-md shadow-lg dark:bg-gray-900 dark:text-white dark:border-gray-800">
        <CardHeader className="space-y-1 flex flex-col items-center">
          <div className="w-12 h-12 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center mb-4">
            <LockIcon className="h-6 w-6 text-red-600 dark:text-red-400" />
          </div>
          <CardTitle className="text-2xl font-bold text-center dark:text-white">
            Access Denied
          </CardTitle>
          <CardDescription className="text-center dark:text-gray-300">
            You don't have permission to access this resource
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-amber-50 dark:bg-amber-900/30 p-3 rounded-md flex items-start space-x-3">
            <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5" />
            <div className="text-sm text-amber-800 dark:text-amber-300">
              <p>
                This content is private or requires authentication. Please sign
                in to continue or create an account if you don't have one.
              </p>
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-3">
          {!isLoggedIn ? (
            <>
              <Button
                className="w-full"
                onClick={() => (window.location.href = "/signin")}
              >
                Sign In
              </Button>
              <Button
                variant="outline"
                className="w-full dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
                onClick={() => {
                  // window.location.href = "/signup";
                  window.location.href =
                    "https://www.waitlistr.com/lists/683824b6/kortex-ai";
                }}
              >
                Create Account
              </Button>
            </>
          ) : (
            <Button
              variant="outline"
              className="w-full dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white"
              onClick={() => navigate("/")}
            >
              Back to Home
            </Button>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};

export default PermissionDenied;
